import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import Bg from 'assets/img/cps/tnf/T&F_background.png'
import FasterBg from 'assets/img/cps/faster.png'
import HigherBg from 'assets/img/cps/higher.png'
import Soon from 'assets/img/cps/cs.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'

import NavigateButton from 'components/NavigateButton'

const Container = styled.div`
	background-image: url(${Bg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 35px 90px;
	position: relative;
`

const MenuContainer = styled.div`
	position: relative;
	padding-top: calc(220px - 35px);
	.itemInner {
		position: relative;
	}
	.itemFaster {
		position: absolute;
		top: 400px;
		left: 15px;
		width: 470px;
		height: 300px;
	}
	.itemMd {
		position: absolute;
		top: 400px;
		left: 630px;
		width: 470px;
		height: 300px;
	}
	.itemHigher {
		position: absolute;
		top: 400px;
		left: 1245px;
		width: 470px;
		height: 300px;
	}
	.listItem {
		display: flex;
		flex-wrap: wrap;
		li {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			width: 50%;
			padding: 0 10px;
			img {
				max-width: 260px;
			}
		}
	}
`

const PageTitle = styled.div`
	position: absolute;
	top: 68px;
	left: 58px;
	font-size: 40px;
	color: #2f302f;
	width: 250px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 100%;
		height: 10px;
		background: #515151;
		margin: 15px 0;
	}
	span {
		font-size: 50px;
	}
`

const TrackList = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [baseLineList, setBaseLineList] = useState<any[]>([])
	const [allCourtList, setAllCourtList] = useState<any[]>([])
	const [bestOfBothList, setBestOfBothList] = useState<any[]>([])

	const [fasterList, setFasterList] = useState<any[]>([])
	const [higherList, setHigherList] = useState<any[]>([])

	const menuMove1 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 100,
	})

	const menuMove2 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 200,
	})

	const menuMove3 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 300,
	})

	const titleMove = useSpring({
		from: { opacity: 0, x: -100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove2 = useSpring({
		from: { opacity: 0, x: 100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const onTouchEnd = (e: any) => {
		console.log(e)
		navigate(`/prun/speed/view`, {
			state: { item: location.state?.item },
		})
	}

	const onItemClick = (item: any, itemType: any) => {
		item.subsortId = location.state.item.subsortId
		item.pageTitle = itemType
		item.subPageTItle = location.state?.item?.title

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: item.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/cps/indoor/view`, { state: { item } })
	}

	const [sdList, setSdList] = useState<any[]>([])
	const [mdList, setMdList] = useState<any[]>([])
	const [ldList, setLdList] = useState<any[]>([])

	useEffect(() => {
		const { item } = location.state
		console.log(item)
		if (item) {
			const request = {
				subsortId: item.subsortId,
				kioskDeviceId: deviceInfo.kioskDeviceId,
			}
			apiThumbnailList(request).then((res) => {
				console.log(res)
				// cpsCategoryId
				{
					/* subSortId가 6이면 (테니스) cpsCate1, 7이면 (배구) cpsCate2, 8이면 (트랙엔필드) cpsCate3, 12면 (기타) cpsCate4 */
				}
				// const cpsCate1 = [
				// 	{ id: 1, cate: 'STABILITY & SPEED', value: 'STABILITY & SPEED' },
				// 	{ id: 2, cate: 'STABILITY', value: 'STABILITY' },
				// 	{ id: 3, cate: 'SPEED', value: 'SPEED' },
				// ]
				// const cpsCate2 = [
				// 	{ id: 4, cate: 'SPEED', value: 'SPEED' },
				// 	{ id: 5, cate: 'CUSHION', value: 'CUSHION' },
				// 	{ id: 6, cate: 'STABILITY', value: 'STABILITY' },
				// ]
				// const cpsCate3 = [
				// 	{ id: 7, cate: 'Short Distance', value: 'Short Distance' },
				// 	{ id: 8, cate: 'Middle Distance', value: 'Middle Distance' },
				// 	{ id: 9, cate: 'Long Distance', value: 'Long Distance' },
				// ]
				// const cpsCate4 = [
				// 	{ id: 10, cate: 'INDOOR', value: 'INDOOR' },
				// 	{ id: 11, cate: 'BASKETBALL', value: 'BASKETBALL' },
				// 	{ id: 12, cate: 'WRESTLING', value: 'WRESTLING' },
				// 	{ id: 13, cate: 'WORKING', value: 'WORKING' },
				// ]
				res.forEach((element: any) => {
					const { cpsCategoryId } = element
					if (cpsCategoryId === 7) {
						setSdList((prev) => [...prev, element])
					} else if (cpsCategoryId === 8) {
						setMdList((prev) => [...prev, element])
					} else if (cpsCategoryId === 9) {
						setLdList((prev) => [...prev, element])
					}
					// if (element.name.startsWith('NET')) {
					// 	setFasterList((prev) => [...prev, element])
					// } else {
					// 	setHigherList((prev) => [...prev, element])
					// }
				})
			})
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, { passive: false })
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			{/* <PageTitle>
				<animated.div style={titleMove}>
					<b>실내스포츠화</b>
					<div className="bar"></div>
					<span className="asics-bold-italic">INDOOR</span>
				</animated.div>
			</PageTitle> */}
			<MenuContainer>
				<animated.div
					className="itemInner"
					style={menuMove1}
				>
					<div className="itemFaster">
						<ul className="listItem">
							{sdList.map((item: any, index: number) => {
								return (
									<li
										key={item.fileId}
										style={{
											width: higherList.length === 1 ? '100%' : '50%',
										}}
									>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt="heritage"
											style={{ width: '100%', height: '100%' }}
											onClick={() => onItemClick(item, 'TRACK & FIELD')}
										/>
									</li>
								)
							})}
						</ul>
					</div>
					<div className="itemMd">
						<ul className="listItem">
							{mdList.map((item: any, index: number) => {
								return (
									<li
										key={item.fileId}
										style={{
											width: higherList.length === 1 ? '100%' : '50%',
										}}
									>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt="heritage"
											style={{ width: '100%', height: '100%' }}
											onClick={() => onItemClick(item, 'TRACK & FIELD')}
										/>
									</li>
								)
							})}
						</ul>
					</div>
					<div className="itemHigher">
						<ul className="listItem">
							{ldList.map((item: any, index: number) => {
								return (
									<li
										key={item.fileId}
										style={{
											width: higherList.length === 1 ? '100%' : '50%',
										}}
									>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt="heritage"
											style={{ width: '100%', height: '100%' }}
											onClick={() => onItemClick(item, 'TRACK & FIELD')}
										/>
									</li>
								)
							})}
						</ul>
					</div>
				</animated.div>
			</MenuContainer>
			<NavigateButton />
		</Container>
	)
}

export default TrackList
